export default __webpack_public_path__ + "static/no-image-c35e2faa96af230e94c2edf9243c4a34.png";